import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './AuditionDetailProducer.module.css';
import Icon from '../../components/common/Icon/Icon';
import { PRODUCER_PLACEHOLDER } from '../../shared/utils/profilePlaceholders';
import { isProducerLogoRemoved } from '../Producer/Company/ProducerCompanyPage';
import { getCastingList } from '../../api/castingApi';

const OPEN_STATUSES = new Set(['PLANNING', 'OPEN', 'IN_PRODUCTION']);
const CLOSED_STATUSES = new Set(['CLOSED']);

function AuditionDetailProducer({ producerInfo, companyId, companyName, isVerified }) {
  const navigate = useNavigate();
  const [activeCastings, setActiveCastings] = useState(producerInfo?.activeCastings ?? 0);
  const [completedProjects, setCompletedProjects] = useState(producerInfo?.completedProjects ?? 0);

  const goToCompany = () => companyId && navigate(`/companies/${companyId}`);

  useEffect(() => {
    if (!companyId) return;
    getCastingList({ producerProfileId: companyId, perpage: 100, size: 100 })
      .then(res => {
        const list = Array.isArray(res) ? res : (res?.content ?? []);
        setActiveCastings(list.filter(c => OPEN_STATUSES.has(c.status)).length);
        setCompletedProjects(list.filter(c => CLOSED_STATUSES.has(c.status)).length);
      })
      .catch(() => {});
  }, [companyId]);

  if (!producerInfo) {
    return <p className={styles.empty}>제작사 정보가 없습니다.</p>;
  }

  return (
    <div className={styles.producer}>
      <div className={styles.card}>
        {/* 로고 */}
        <div
          className={styles.logoWrapper}
          onClick={goToCompany}
          style={companyId ? { cursor: 'pointer' } : undefined}
        >
          {(() => {
            const logoSrc = isProducerLogoRemoved() ? null : producerInfo.logo;
            return (
              <img
                src={logoSrc || PRODUCER_PLACEHOLDER}
                alt={companyName}
                className={styles.logoImage}
                style={{ objectFit: logoSrc ? 'cover' : 'contain' }}
              />
            );
          })()}
        </div>

        {/* 우측 정보 */}
        <div className={styles.content}>
          {/* 회사명 + 인증 */}
          <div className={styles.header}>
            <span
              className={styles.companyName}
              onClick={goToCompany}
              style={companyId ? { cursor: 'pointer', textDecoration: 'underline' } : undefined}
            >
              {companyName}
            </span>
            {isVerified && (
              <div className={styles.verifiedBadge}>
                <Icon name="verified" size="20" color="#FFA40D" />
                <span className={styles.verifiedText}>인증됨</span>
              </div>
            )}
          </div>

          {/* 회사 소개 */}
          {producerInfo.description && (
            <p className={styles.description}>{producerInfo.description}</p>
          )}

          {/* 통계 */}
          <div className={styles.stats}>
            <span className={styles.statItem}>
              진행 중인 캐스팅 : <strong>{activeCastings}건</strong>
            </span>
            <span className={styles.statDivider} aria-hidden="true" />
            <span className={styles.statItem}>
              완료된 프로젝트 : <strong>{completedProjects}건</strong>
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AuditionDetailProducer;
